import moment from "moment";
import { offeringCloseInstant } from "@/utils/offeringClose";

export default {
  investment_maturity(home) {
    return new Date().getFullYear() + home.term_of_investment;
  },
  ltv(home) {
    return (
      Math.round(
        (10000 * (home.debt + home.additional_debt)) / home.valuation
      ) / 100
    );
  },
  dividend_range(home) {
    return {
      min: home.calculator_results.Dividend_Schedule.reduce((prev, curr) =>
        prev.Dividend < curr.Dividend ? prev : curr
      ).Dividend,
      max: home.calculator_results.Dividend_Schedule.reduce((prev, curr) =>
        prev.Dividend < curr.Dividend ? curr : prev
      ).Dividend,
    };
  },
  funding_round_days_left(home) {
    // The close instant: the end of the stored date in ET (2026-10-20).
    return moment(offeringCloseInstant(home.funding_round_end)).diff(moment.utc(), "days");
  },
};
